import { render, staticRenderFns } from "./Extended-Warranty.vue?vue&type=template&id=a161f506&scoped=true"
import script from "./Extended-Warranty.vue?vue&type=script&lang=js"
export * from "./Extended-Warranty.vue?vue&type=script&lang=js"
import style0 from "./Extended-Warranty.vue?vue&type=style&index=0&id=a161f506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a161f506",
  null
  
)

export default component.exports